// src/pages/rules/DeleteRuleModal.jsx
//
// Delete confirmation for a single rule. Split out of RulesConfigPage.jsx.

import PropTypes from "prop-types";
import { Trash2 } from "lucide-react";
import { Button, Modal } from "../../shared/ui";

export default function DeleteRuleModal({ target, onClose, onConfirm }) {
  return (
    <Modal
      open={!!target}
      title="Delete rule?"
      onClose={onClose}
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={() => onConfirm(target.id)}>
            <Trash2 size={14} /> Delete
          </Button>
        </>
      }
    >
      <p className="text-sm text-slate-600">
        Delete <strong className="text-ink">{target?.name}</strong>? This can't be undone.
      </p>
    </Modal>
  );
}

DeleteRuleModal.propTypes = {
  target: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
  }),
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};
